var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form-group row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("profile.financial_facilities.s_no"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.s_no) } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "input-label" }, [
            _vm._v(
              _vm._s(_vm.$tc("profile.financial_facilities.facility_nature"))
            ),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.formData.facility_nature) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "input-label" }, [
            _vm._v(_vm._s(_vm.$tc("profile.financial_facilities.type"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.formData.facility_type) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "input-label" }, [
            _vm._v(
              _vm._s(
                _vm.$tc("profile.financial_facilities.existing_enhancement")
              )
            ),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.formData.facility_origin) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("profile.financial_facilities.bank_name"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.formData.bank_name) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("profile.financial_facilities.collaterals"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.formData.collaterals) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("profile.financial_facilities.tenor"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.tenor) } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("profile.financial_facilities.amount"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          _vm._v(" "),
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$utils.formatMoney(_vm.amount, _vm.defaultCurrency)
              ),
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(
              _vm._s(_vm.$t("profile.financial_facilities.amount_overDue"))
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$utils.formatMoney(_vm.amount_overDue, _vm.defaultCurrency)
              ),
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-footer" },
      [
        _c(
          "base-button",
          {
            staticClass: "mr-3",
            attrs: { outline: true, color: "theme", type: "button" },
            on: { click: _vm.closeFinancialModal },
          },
          [_vm._v("\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }